import { render, staticRenderFns } from "./AttributeSetUpdater.vue?vue&type=template&id=3f965b81"
import script from "./AttributeSetUpdater.vue?vue&type=script&lang=js"
export * from "./AttributeSetUpdater.vue?vue&type=script&lang=js"
import style0 from "./AttributeSetUpdater.vue?vue&type=style&index=0&id=3f965b81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports